import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import TitleBasic from '@adv-mt/mt-title-basic'

import {BASE_CLASS} from '../settings.js'

export function Error({title, description, image, onBack, onExit}) {
  const {i18n} = useContext(Context)
  return (
    <div className={`${BASE_CLASS}Error`}>
      <span>
        <TitleBasic as="h3" size="m" title={title} description={description} />
      </span>
      <AtomImage className={`${BASE_CLASS}Error-image`} src={image} />
      <div className={`${BASE_CLASS}Error-buttonGroup`}>
        <AtomButton
          className={`${BASE_CLASS}Error-button`}
          design={atomButtonDesigns.OUTLINE}
          shape={atomButtonShapes.CIRCULAR}
          onClick={onExit}
        >
          {i18n.t('COMMON.EXIT')}
        </AtomButton>
        <AtomButton
          className={`${BASE_CLASS}Error-button`}
          design={atomButtonDesigns.SOLID}
          shape={atomButtonShapes.CIRCULAR}
          onClick={onBack}
        >
          {i18n.t('COMMON.GO_BACK')}
        </AtomButton>
      </div>
    </div>
  )
}

Error.displayName = 'StepperFlowError'
Error.propTypes = {
  description: PropTypes.string,
  image: PropTypes.string,
  onBack: PropTypes.func,
  onExit: PropTypes.func,
  title: PropTypes.string
}
